import styles from './OrganisationList.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { OrganisationCardProps, UI_OrganisationCard } from 'ui/components/2-molecules/Card/OrganisationCard/OrganisationCard';
import { UI_LinkWithIcon } from 'ui/components/1-atoms/Action/LinkWithIcon/LinkWithIcon';
import IconArrow from 'ui/icons/icon_right_arrow.svg';

export interface OrganisationListProps {
	heading?: string;
	link?: { url: string; target?: string; name: string };
	items: OrganisationCardProps[];
}
export const UI_OrganisationList = ({ heading, link, items }: OrganisationListProps) => {
	return (
		<div className={styles.OrganisationList}>
			{heading && (
				<UI_Heading className={styles.OrganisationList_heading} headingLevel="h2" style="lg50">
					{heading}
				</UI_Heading>
			)}
			{link?.url && (
				<UI_LinkWithIcon
					className={styles.OrganisationList_link}
					url={link.url}
					target={link.target}
					icon={
						<span className={styles.OrganisationList_linkIcon}>
							<IconArrow />
						</span>
					}
					text={link.name}
				/>
			)}
			<div className={styles.OrganisationList_items}>
				{items?.map((item, index) => <UI_OrganisationCard className={styles.OrganisationList_card} key={index} {...item} />)}
			</div>
		</div>
	);
};
